import { createRoute } from '@tanstack/react-router';
import { adminParentRoute } from 'pages/admin/adminParentRoute';
import { zodOptionalDateRange, zodOptionalId, zodOptionalString } from 'routes/routeUtils';
import { z } from 'zod';

export const adminIngestionsHubRoute = createRoute({
  getParentRoute: () => adminParentRoute,
  path: '/tools/ingestions',
  validateSearch: z.object({
    query: zodOptionalString,
    labId: zodOptionalId,
    groupId: zodOptionalId,
    createdAtRange: zodOptionalDateRange,
  }),
}).lazy(() =>
  import('pages/admin/IngestionsHub/AdminIngestionsHubPage/AdminIngestionsHubPage').then(
    (d) => d.Route
  )
);
